<template>
    <v-navigation-drawer :mini-variant.sync="mini" mini-variant-width="3vw" class="content" expand-on-hover fixed permanent v-model="drawer">
        <v-list-item @click="goToProfile">
            <v-list-item-avatar>
                <v-img :src="this.$store.state.user.imageUrl"></v-img>
            </v-list-item-avatar>
            <v-list-item-title><p class="text mt-5">{{ $t('profile') }}</p></v-list-item-title>
        </v-list-item>

        <v-divider color="grey" class="my-2"/>

        <v-list dense>
            <v-list-item class="mb-1" :key="item.title" link v-for="item in items" @click="option(item)">
                <v-list-item-icon>
                    <v-icon color="#00F784" v-if="item.title === itemSelected">{{ item.icon }}</v-icon>
                    <v-icon color="#FFFFFF" v-else>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="ml-n3">
                    <v-list-item-title v-if="item.title === itemSelected"><p style="color: #00F784" class="text mb-0">
                      {{item.title}}
                      <v-chip class="ml-1" v-if="item.beta" color="#00F784" x-small><span style="font-size: 14px;">Beta</span></v-chip>
                    </p></v-list-item-title>
                    <v-list-item-title v-else><p class="text mb-0">
                      {{item.title}}
                      <v-chip class="ml-1" v-if="item.beta" x-small><span style="font-size: 13px;">Beta</span></v-chip>
                    </p></v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>

        <template v-slot:append>
            <v-list dense>
              <!--v-list-item class="mb-1" @click="$router.push('/feedback')">
                <v-list-item-icon>
                  <v-icon color="#FFFFFF">fa-rocket</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="ml-n3">
                  <v-list-item-title><p class="text mb-0">{{ $t('newFeatures') }}</p></v-list-item-title>
                </v-list-item-content>
              </v-list-item!-->
              <v-list-item class="mb-1">
                <v-list-item-icon><v-icon color="accent">fa-bell</v-icon></v-list-item-icon>
                <v-list-item-content class="ml-n4">
                  <v-list-item-title>
                    <p class="mb-0">
                      <a href="#" class="text-news ak-trigger">{{ $t('appNews') }}
                        <AnnounceKit catchClick=".ak-trigger" widget="https://announcekit.app/widget/3yineg"/>
                      </a>
                    </p>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="mb-1" @click="signOut">
                <v-list-item-icon>
                  <v-icon color="#FFFFFF">fa-arrow-right-from-bracket</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="ml-n4">
                  <v-list-item-title><p style="color: #FFFFFF" class="text mt-1">{{ $t('logout') }}</p></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
        </template>
    </v-navigation-drawer>
</template>

<script>
    import AnnounceKit from 'announcekit-vue';
    import { mapMutations } from 'vuex';
    import { Auth } from 'aws-amplify';

    export default {
        name: "Navbar",
        components: {
            AnnounceKit,
        },
        mounted() {
          this.getItems();
        },
        watch: {
          '$i18n.locale': function () {
            this.getItems();
          },
        },
        data() {
            return {
                name: this.$store.state.user.name,
                drawer: true,
                items: [],
                itemSelected: 'Dashboard',
                mini: true,
            };
        },
        methods: {
            getItems() {
              this.items = [
                {title: this.$t('items.tableDashboard'), icon: 'fa-tachometer-alt', path: '/dashboard', beta: false},
                {title: this.$t('items.tableWatchlist'), icon: 'fa-binoculars', path: '/watchlist', beta: false},
                {title: this.$t('items.tableJournal'), icon: 'fa-stream', path: '/journal', beta: false},
                {title: this.$t('items.tableCalendar'), icon: 'fa-calendar-alt', path: '/calendar', beta: false},
                {title: this.$t('items.tableMentor'), icon: 'fa-brain', path: '/mentor', beta: true},
                {title: this.$t('items.tablePlan'), icon: 'fa-swatchbook', path: '/plan', beta: false},
                {title: this.$t('items.tableFunding'), icon: 'fa-search-dollar', path: '/funding-simulation', beta: false},
                {title: this.$t('items.tableTournaments'), icon: 'fa-trophy', path: '/tournaments', beta: false},
                {title: this.$t('items.tableCommunity'), icon: 'fa-users', path: '/community', beta: false},
                {title: this.$t('items.tableChart'), icon: 'fa-chart-line', path: '/analysis', beta: false},
              ];
              if(this.$store.state.user.id === 7 || this.$store.state.user.id === 5/* || this.$store.state.user.id === 596*/)
                this.items.push({title: this.$t('items.tableHallOfFame'), icon: 'fa-crown'/*'fa-ranking-star'*/, path: '/hall-of-fame/forex', beta: false});
            },
            ...mapMutations(['clearData']),
            async signOut() {
                this.clearData();
                await Auth.signOut()
                this.$router.push('/');
            },
            option(item) {
                this.itemSelected = item.title;
                this.$router.push(item.path);
            },
            goToProfile() {
                this.$router.push('/profile');
            }
        },
    }
</script>

<i18n>
{
    "en": {
      "logout": "Logout",
      "appNews": "App News",
      "newFeatures": "New Features",
      "profile": "My Profile",
      "items": {
        "tableDashboard":"Dashboard",
        "tableWatchlist":"Watchlist",
        "tableJournal":"Trading Journal",
        "tableCalendar":"Calendar",
        "tableMentor":"Trading Mentor",
        "tablePlan":"Trading Plan",
        "tableTournaments":"Tournaments",
        "tableCommunity":"Community",
        "tableChart":"Technical Chart",
        "tableFunding": "Funding Hunt ™",
        "tableHallOfFame": "Hall of Fame"
      }
  },
    "es": {
      "logout": "Cerrar sesión",
      "appNews": "Noticias de Swiset",
      "newFeatures": "Nuevas Funcionalidades",
      "profile": "Mi Perfil",
      "items": {
        "tableDashboard":"Dashboard",
        "tableWatchlist":"Lista de Seguimiento",
        "tableJournal":"Bitácora de Trading",
        "tableCalendar":"Calendario",
        "tableMentor":"Mentor de Trading",
        "tablePlan":"Plan de Trading",
        "tableTournaments":"Torneos",
        "tableCommunity":"Comunidad",
        "tableChart":"Gráfico Técnico",
        "tableFunding": "Funding Hunt ™",
        "tableHallOfFame": "Salón de la Fama"
    }
  }
}
</i18n>

<style lang="scss" scoped>
    @import "../global";

    .content {
        background-color: rgba(17, 17, 17, 0.87) !important;
        backdrop-filter: blur(5px) !important;
        border-bottom-right-radius: 10px !important;
        border-top-right-radius: 10px !important;
        z-index: 1000 !important;
    }

    .text {
        color: $white-color;
        font-size: 14px;
    }

    .text-news {
        color: #fff75f;
        font-size: 14px;
        text-decoration: none;
    }
</style>
